import * as TagActions from './tag.actions';
import * as TagApiActions from './tag-api.actions';

export { TagActions, TagApiActions };
